import React from "react";
import styled from "styled-components";

const Promotion = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin: 4px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #333;
  color: #ffffff;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.75px;
  line-height: 40px;
  text-align: center;
`;

interface IProps {
  promotion?: string | undefined;
}

const ProductPromotion = ({ promotion }: IProps): JSX.Element | null => {
  if (promotion) {
    return <Promotion>{promotion}</Promotion>;
  }

  return null;
};

export default ProductPromotion;
